import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forgotten-password-complete',
  templateUrl: './forgotten-password-complete.component.html',
  styleUrls: ['./forgotten-password-complete.component.scss'],
  host: { 'class': 'login-main' }
})
export class ForgottenPasswordCompleteComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }


}
